import axios from '@/lib/axios';
import RegistrationInParams from '../types/RegistrationParams';

const registration = (data: RegistrationInParams) => {
  return axios.patch('/facility', data);
}

export default registration;